import { DataProvider } from 'react-admin';

export const updatePartialByIds = (
  dataProvider: DataProvider,
  resource: string,
  ids: Array<number | string>,
  data: Record<string, unknown>
) =>
  ids.length === 1
    ? dataProvider.updatePartial(resource, { id: ids[0], data })
    : dataProvider.updateManyPartial(resource, { data: { ids, data } });
